import { useEstimateStructure, ValueCell } from "@tools";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";

export const FixedCompanyCostCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { settings } = structure;
  const { currencyObj, companyFixedBreakdownCost, priceFormat } = settings;
  
  const handleCostChange = (v) =>
    settings.setCompanyBreakdownFixedCost(v);
  
  return <ValueCell
    colName={ SummaryColumns.C_COST }
    useDynamicWidth
    fullWidthInputs
    displayContent
    editable
    value={companyFixedBreakdownCost}
    onValueChange={handleCostChange}
    symbolStart={currencyObj.symbolStart}
    symbolEnd={currencyObj.symbolEnd}
    americanFormat={priceFormat === PriceFormats.AMERICAN}
    applySuffixSpacing
    max={10000000}
    {...cellProps}
  />
})